import { ListPaginationMeta } from "utils/helpers/pagination";

export type FrontClearanceFilterValue = string;

export enum FrontClearanceFilterEnum {
  Manufacturers = "manufacturers",
  Models = "models",
  SuperModels = "superModels",
  Years = "years",
}

export interface FrontClearanceFilterOption {
  id: number;
  name: string;
}

export type FrontClearanceFilterOptions = Record<
  FrontClearanceFilterEnum,
  FrontClearanceFilterOption[]
>;

export interface FrontClearanceRow {
  superModelId: number;
  superModelName?: string;
  year: number;
  cabinType: string;
  structureTypeId: number;
  structureTypeName?: string;
  normalFrontSpace?: number;
  minFrontSpace?: number;
  manufacturerId?: number;
  manufacturerName?: string;
  modelId?: number;
  modelName?: string;
  remarks?: string;
}

export interface FrontClearanceForm {
  manufacturer: string;
  masterModel: string;
  year: string;
  driverCabin: string;
  bodyType: string;
  optimalDistance: string;
  minimalDistance: string;
  note: string;
}

export type FrontClearanceListMeta = ListPaginationMeta;

export type FrontClearanceFormDropDownKey = "manufacturers" | "superModels";

export type FrontClearanceFormDropDownState = {
  items: FrontClearanceFilterOption[];
  page: number;
  perPage: number;
  meta: FrontClearanceListMeta;
  loading: boolean;
};

export type FrontClearanceFormDropDowns = Record<
  FrontClearanceFormDropDownKey,
  FrontClearanceFormDropDownState
>;

export interface FrontClearanceListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: FrontClearanceRow[];
  meta?: FrontClearanceListMeta;
}

export interface FrontClearanceFilterOptionsResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: Record<string, FrontClearanceFilterOption[]>;
  meta?: FrontClearanceListMeta;
}

export interface FrontClearanceUpdatePayload {
  superModel: number;
  year: number;
  cabinType: string;
  structureType: number;
  normalFrontSpace: number;
  minFrontSpace: number;
  manufacturer: number;
  model: number;
  remarks: string;
}

export interface FrontClearanceDeletePayload {
  superModel: number;
  year: number;
  cabinType: string;
  structureType: number;
}

export interface FrontClearanceState {
  loading: boolean;
  saving: boolean;
  list: FrontClearanceRow[];
  page: number;
  perPage: number;
  meta: FrontClearanceListMeta;
  error: string | null;
  manufacturerFilter: FrontClearanceFilterValue;
  masterModelFilter: FrontClearanceFilterValue;
  yearFilter: FrontClearanceFilterValue;
  filterOptions: FrontClearanceFilterOptions;
  filterOptionsLoading: boolean;
  filterOptionsError: string | null;
  isAddModalOpen: boolean;
  form: FrontClearanceForm;
  formDropDowns: FrontClearanceFormDropDowns;
}
